import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-478.000000, -3111.000000)" fill={color}>
                <g id="Group-6-Copy-2" transform="translate(435.000000, 3068.000000)">
                    <path d="M62.2196782,62.3256832 L66.2203205,72.0415287 L73.0785643,51.4667971 L62.2196782,62.3256832 Z M70.5332029,48.9214357 L49.9584713,55.7796795 L59.6743168,59.7803218 L70.5332029,48.9214357 Z M64.733717,77.8854055 L58.7198063,63.2801937 L44.1145945,57.266283 C42.572543,56.6313206 42.6486399,54.4218893 44.230724,53.8945279 L76.6278855,43.0954741 C78.0349266,42.6264604 79.3735396,43.9650734 78.9045259,45.3721145 L68.1054721,77.769276 C67.5781107,79.3513601 65.3686794,79.427457 64.733717,77.8854055 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconSend extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
